import { useEffect, useState } from "react";

export default function useActiveSection(links) {
  const [active, setActive] = useState("home");
  useEffect(() => {
    const handler = () => {
      const scrollY = window.scrollY + 100;
      let current = links[0].href.slice(1);
      links.forEach(({ href }) => {
        const id = href.slice(1);
        const el = document.getElementById(id);
        if (el && el.offsetTop <= scrollY) current = id;
      });
      setActive(current);
    };
    window.addEventListener("scroll", handler, { passive: true });
    handler();
    return () => window.removeEventListener("scroll", handler);
  }, [links]);
  return active;
}
